import { isFeatureEnabled } from 'owa-feature-flags';
import bucket from 'owa-timestream-asset-bucket';
import calendar from 'owa-timestream-asset-calendar';
import clock from 'owa-timestream-asset-clock';
import file from 'owa-timestream-asset-filepicker';
import { default as fluid, table } from 'owa-timestream-asset-fluid';
import goal from 'owa-timestream-asset-goal';
import link from 'owa-timestream-asset-link';
import location from 'owa-timestream-asset-location';
import note from 'owa-timestream-asset-note';
import people from 'owa-timestream-asset-people';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import tasklist from 'owa-timestream-asset-task-list';
import tips from 'owa-timestream-asset-tips';
import weather from 'owa-timestream-asset-weather';
import image from 'owa-timestream-asset-imagepicker';
import { calendarItem } from 'owa-timestream-asset-calendaritem';
import { mailItem } from 'owa-timestream-asset-mailitem';
import { taskItem } from 'owa-timestream-asset-task';

/** List of assets that should show up in asset creation UX (initial collapsed menu), in order. */
const INITIAL_MENU_ASSETS = isFeatureEnabled('cal-board-addMenuOrdering')
    ? ([calendar, note, tasklist, bucket, goal, file] as AssetDescriptor[])
    : ([calendar, tasklist, note, weather] as AssetDescriptor[]);

/** List of assets that should show up in asset creation UX (full expanded menu), in order. */
const EXPANDED_MENU_ASSETS = isFeatureEnabled('cal-board-addMenuOrdering')
    ? ([link, image, table, weather, clock, people, fluid, location, tips] as AssetDescriptor[])
    : ([
          goal,
          link,
          image,
          file,
          table,
          location,
          people,
          clock,
          fluid,
          tips,
          bucket,
      ] as AssetDescriptor[]);

/** List of assets that should show up in asset creation UX, in order. */
const MENU_ASSETS = [...INITIAL_MENU_ASSETS, ...EXPANDED_MENU_ASSETS];

/** All usable assets, required for registration. */
const FUNCTIONAL_ASSETS = [
    ...MENU_ASSETS,
    // indirect-add only
    mailItem,
    calendarItem,
    taskItem,
] as AssetDescriptor[];

/** Assets that can create content during a paste operation, in order of precedence. */
const PASTE_PRECEDENCE = [fluid, file, link, note] as AssetDescriptor[];

/**
 * Gets the registry of all the assets
 */
export const ASSET_REGISTRY = {
    functionalAssets: FUNCTIONAL_ASSETS,
    menuAssets: MENU_ASSETS,
    pastePrecedence: PASTE_PRECEDENCE,
};

/** Show initial assets (enabled only) and one overflow ("Show all") button */
export function getNumInitialMenuItems(): number {
    return INITIAL_MENU_ASSETS.filter(asset => asset.isAssetEnabled?.() ?? true).length + 1;
}
